import React from 'react'

function NovaPropostaModeloCliente() {
  return (
    <div style={{padding: '10rem'}}>NovaPropostaModeloCliente</div>
  )
}

export default NovaPropostaModeloCliente
